var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}import React from 'react';

import { Translate } from "../../I18N";





export const ErrorFallback = (props) => {var _props$error$code, _props$errorInfo;
  const showRequestId = ((_props$error$code = props.error.code) === null || _props$error$code === void 0 ? void 0 : _props$error$code.toString()) === '500' && props.error.requestId;
  const errorDetails = ((_props$errorInfo = props.errorInfo) === null || _props$errorInfo === void 0 ? void 0 : _props$errorInfo.componentStack) || props.error.message;
  return /*#__PURE__*/(
    _jsx("div", { className: "error-fallback-ui" }, void 0, /*#__PURE__*/
    _jsx("div", { className: "message" }, void 0, /*#__PURE__*/
    _jsx("p", { className: "error-message-xxl" }, void 0,
    props.error.summary && /*#__PURE__*/_jsx(Translate, {}, void 0, props.error.summary),
    !props.error.summary && /*#__PURE__*/_jsx(Translate, {}, void 0, "Well, this is awkward...")
    ), /*#__PURE__*/
    _jsx("p", { className: "error-message-lg" }, void 0,
    props.error.name && /*#__PURE__*/_jsx(Translate, {}, void 0, props.error.name),
    !props.error.name && /*#__PURE__*/_jsx(Translate, {}, void 0, "Something went wrong")
    ), /*#__PURE__*/
    _jsx("p", {}, void 0, /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Please contact an admin for details.")
    ),
    showRequestId && /*#__PURE__*/
    _jsx("p", { className: "error-message-sm" }, void 0, /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Request id #"),
    props.error.requestId
    ),

    errorDetails && /*#__PURE__*/
    _jsx("details", { className: "error-details" }, void 0, /*#__PURE__*/
    _jsx(Translate, {}, void 0, errorDetails)
    )

    ),
    props.error.code && /*#__PURE__*/_jsx("span", { className: "error-code" }, void 0, props.error.code)
    ));

};